export default __webpack_public_path__ + "static/mitsubishi_mirai-logo-3572757c5576c4f2ba0f2e3d20b744ba.svg";